<template>
  <q-page padding>
    <div class="relative-position loader">
      <event-groups :event-id="eventId"></event-groups>
    </div>
  </q-page>
</template>

<script>
import EventGroups from '../../../components/events/groups'

export default {
  components: { EventGroups },
  computed: {
    eventId () {
      if (this.$route && this.$route.params && this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }
      return null
    }
  }
}
</script>
